module.exports = __webpack_public_path__ + "media/images/form-background-top-84237d8f.png";